import { TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class OutBoundRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    palletNo: number;
    // @ApiProperty({
    //     enum: TransactionType,
    //     default: TransactionType.dispatch
    //   })
    //   transactionType: TransactionType;
  }
